module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_4.fc5b4dea.png";